import { Component, OnInit, Inject } from '@angular/core';
import { TagInputModule } from 'ngx-chips';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { Http, Response } from "@angular/http";
import { RestApiService } from '../shared/restApiServices/restapi.service';
import { Observable } from 'rxjs/Observable';
import 'rxjs/add/operator/filter';
import 'rxjs/add/observable/of';
import 'rxjs/add/operator/first';
import 'rxjs/add/operator/debounceTime';
import { MAT_DIALOG_DATA } from '@angular/material';
import { MatDialogRef } from '@angular/material';
import { isUndefined } from "util";


@Component({
  selector: 'app-manage-surveyer-dialog',
  templateUrl: './manage-surveyer-dialog.component.html',
  styleUrls: ['./manage-surveyer-dialog.component.css']
})
export class ManageSurveyerDialogComponent implements OnInit {

  name: boolean;
  Name: string;
  userName: string;
  createdAt: string;
  status: string;
  userID: string;
  teams: string[];

  constructor(private http: Http, private restApiService: RestApiService, @Inject(MAT_DIALOG_DATA) public data: any, public manageSurveyerDialogRef: MatDialogRef<ManageSurveyerDialogComponent>) { }

  ngOnInit() {
    if (this.data.Name) {
      this.name = true;
      this.Name = this.data.Name;
    }
    this.userName = this.data.userName;
    this.status = this.data.Status;
    this.createdAt = this.data.createdAt;
    this.userID = this.data.uID;
    this.teams = [];
    if (this.status == "Added") {
      if (this.data.Team) {
        this.teams.push(this.data.Team);
      }
      else {
        this.teams.push("No teams assigned");
      }
    }
    else {
      this.teams.push("Teams cannot be assigned");
    }
  }

  onCancel() {
    this.manageSurveyerDialogRef.close({
      success: true
    });
  }

}



// WEBPACK FOOTER //
// ./src/app/manage-surveyer-dialog/manage-surveyer-dialog.component.ts